import { createReducer } from "@reduxjs/toolkit";
import isSentryEnabled from "utils/isSentryEnabled";

export const sentryConfigured = createReducer<boolean>(
  Boolean(isSentryEnabled() && process.env.REACT_APP_SENTRY_DSN),
  {},
);
